
import AppContactInfo from "@/components/contacts/ContactInfo.vue";
import { Contact } from "@/models/base";
import { ToolbarService } from "@/services/toolbar-service";
import Vue from "vue";
import { getContactServiceByGroupId} from "@/utils/services/contact-services";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data() {
		return {
			id: 0,
			contact: null  as null | Contact
		};
	},
	props: {
		groupId: {
			type: Number
		}
	},
	computed: {
		title():TranslateResult{
			return ToolbarService.title;
		},
	},
	methods: {
		close(){
			this.$emit("close");
		}
	},
	async created() {
		let titleKey = "titles.";
		this.id = parseInt(this.$route.params.id);
		let contactService = getContactServiceByGroupId(this.groupId);
		this.contact = await contactService.getContact(this.id);
		let titleGroups = ["client", "supplier", "prospect"];
		titleKey += titleGroups[this.contact.GroupID - 1];
		titleKey += "-";
		titleKey += "info";
		await this.$nextTick();
		ToolbarService.title = this.$ct(titleKey);
	},
	components: {
		AppContactInfo
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	},
	beforeRouteLeave(to,from,next){
		next();
		let contact = this.contact as Contact;
		this.contact = null;
		let contactService = getContactServiceByGroupId(contact.GroupID);
		contactService.lastOpenedItem.setLastOpenedItem(contact.getJSON());
	}
});
